import { useState, useEffect, RefObject } from 'react';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from '@instamenu/ui-vanilla-extract';

export const useElementSticky = (
  ref: RefObject<HTMLElement | null>,
  mobileTop = 0,
  desktopTop = 60,
) => {
  const [isSticky, setIsSticky] = useState(false);
  const isDesktop = useMediaQuery({ query: breakpoints.tablet });

  useEffect(() => {
    const handleScroll = () => {
      const element = ref.current;
      if (!element) return;

      const rect = element.getBoundingClientRect();
      const expectedTop = isDesktop ? desktopTop : mobileTop;

      setIsSticky(rect.top <= expectedTop);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDesktop, ref, mobileTop, desktopTop]);

  return isSticky;
};
